var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
  'wgt-custom-wgt': true,
  'padded': _vm.value.padded
}},[(_vm.refresh)?_c('div',[(!_vm.value.data || _vm.value.data.length == 0)?_c('div',{staticClass:"wgt-custom-wgt-bd"},[_c('div',[_vm._v("点击编辑“自定义页面模块”")])]):_vm._e(),(_vm.value.data)?_c('div',_vm._l((_vm.value.data),function(wgt,index){return _c(wgt.name,{key:`ab-component__${index}`,tag:"component",attrs:{"value":wgt}})}),1):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }